export default __webpack_public_path__ + "static/media/check-white.f56a24a4.svg";